import { apiClient, type Paginated } from '@/lib/api-client';

export interface DeliveryLogRow {
  DeliveryLogID: string;
  EventID: string | null;
  NotificationID: string | null;
  EventType: string;
  EntityType: string | null;
  EntityID: string | null;
  RecipientPersonID: string;
  Channel: 'InApp' | 'Email' | 'WhatsApp';
  Recipient: string;
  SenderProfileID: string | null;
  Subject: string | null;
  BodyPreview: string | null;
  Status: 'Queued' | 'Sent' | 'Failed' | 'Skipped';
  AttemptCount: number;
  ErrorMessage: string | null;
  QueuedOn: string | null;
  SentOn: string | null;
}

export interface DeliveryLogFilters {
  channel?: string;
  status?: string;
  eventType?: string;
  recipient?: string;
  dateFrom?: string;
  dateTo?: string;
  limit?: number;
  offset?: number;
}

export const deliveryLogApi = {
  list(filters: DeliveryLogFilters): Promise<Paginated<DeliveryLogRow>> {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== undefined && v !== '') params.set(k, String(v));
    });
    return apiClient.getPage<DeliveryLogRow>(`/admin/delivery-log?${params}`);
  },
  resend(id: string) {
    return apiClient.post(`/admin/delivery-log/${id}/resend`);
  },
};
